import { useQuery } from '@tanstack/react-query';
import { companyService } from '@/api/services/CompanyService';
import { useAuth } from '@/stores/authContext';

export const COMPANY_CARD_QUERY_KEY = ['companyCard'] as const;

// Карточка организации (server-state). Включена только при авторизации.
export function useCompanyCard() {
  const { isAuthenticated } = useAuth();
  return useQuery({
    queryKey: COMPANY_CARD_QUERY_KEY,
    queryFn: () => companyService.getCompanyCard(),
    enabled: isAuthenticated,
    staleTime: 5 * 60_000,
  });
}
